import React, { Component } from "react";
import "./SecretComponent.css";
import * as THREE from 'three';
import ColorChange from "./ColorChange";

function SecretFunction() {
  var x = document.getElementById("egg").value;
  x = x.toLowerCase();
  switch (x) {
    case "hi":
      document.getElementById("demo").innerHTML = "Hello";
      break;
    case "hello":
      document.getElementById("demo").innerHTML = "Hi";
      break;
    case "howdy":
      document.getElementById("demo").innerHTML = "🤠";
      break;
    case "nicolas amatuzio":
      document.getElementById("demo").innerHTML = "That's me!";
      break;
    case "hide":
      document.getElementById("shown").hidden = true;
      document.getElementById("demo").innerHTML = "Bye bye!";
      break;
    case "show":
      document.getElementById("shown").hidden = false;
      document.getElementById("demo").innerHTML = "Welcome back!";
      break;
    case "secret":
      document.getElementById("shown").hidden = true;
      document.getElementById("demo").innerHTML = "loading...";
      break;
    default:
      document.getElementById("demo").innerHTML = x;
      break;
  }
}

function formPreventDefault(e) {
  e.preventDefault();
}

export default function SecretComponent() {
  return (
    <div>
      <div>
      <h2 id="demo" style={{minHeight: "40px"}}></h2>
      </div>
      <form onSubmit={formPreventDefault} onChange={SecretFunction}>
        <input
          type={"text"}
          id="egg"
          className="secret-textarea"
          placeholder="Enter secret phrases"
          autoComplete="off"
          maxLength={20}
        ></input>
      </form>
    </div>
  );
}
